function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.31 90.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.33,6.16h-69a4.54,4.54,0,0,0-4.48,4.59V41.8a1.75,1.75,0,1,0,3.49,0v-31a1,1,0,0,1,1-1h69a1,1,0,0,1,1,1v69.5a1,1,0,0,1-1,1h-69a1,1,0,0,1-1-1V56a3.38,3.38,0,0,0,1.53-2.83,3.33,3.33,0,0,0-3.28-3.36,3.32,3.32,0,0,0-3.27,3.36A3.36,3.36,0,0,0,6.89,56v24.3a4.54,4.54,0,0,0,4.48,4.59h69a4.54,4.54,0,0,0,4.48-4.59V10.75A4.54,4.54,0,0,0,80.33,6.16Z",
    style: {
      fill: "#006098"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.76,39.4h-4.7V38.32a5.28,5.28,0,0,0-.76-2.86,2.8,2.8,0,0,0-2.56-1.21,2.94,2.94,0,0,0-1.57.38,3.11,3.11,0,0,0-1,.95A3.92,3.92,0,0,0,34.7,37a9.51,9.51,0,0,0-.14,1.63,15.2,15.2,0,0,0,.07,1.65A3.08,3.08,0,0,0,35,41.43a2.53,2.53,0,0,0,.8.9,7.34,7.34,0,0,0,1.45.76l3.6,1.46A8.86,8.86,0,0,1,43.36,46a6.1,6.1,0,0,1,1.52,1.92,8.88,8.88,0,0,1,.69,2.57,26.5,26.5,0,0,1,.19,3.28,17.6,17.6,0,0,1-.42,4A8.37,8.37,0,0,1,44,60.8a6.76,6.76,0,0,1-2.54,2.08,8.79,8.79,0,0,1-3.82.75A8.15,8.15,0,0,1,34.47,63a7.61,7.61,0,0,1-2.54-1.7,8.47,8.47,0,0,1-1.68-2.53,7.93,7.93,0,0,1-.62-3.14V53.86h4.7v1.51a4,4,0,0,0,.76,2.38,2.93,2.93,0,0,0,2.56,1.07,3.94,3.94,0,0,0,1.86-.36,2.47,2.47,0,0,0,1-1A3.8,3.8,0,0,0,41,55.86c0-.61.07-1.29.07-2A21.23,21.23,0,0,0,41,51.64a4,4,0,0,0-.37-1.37,2.59,2.59,0,0,0-.86-.85,10.53,10.53,0,0,0-1.4-.71L35,47.29a7.45,7.45,0,0,1-4.08-3.38,11.85,11.85,0,0,1-1-5.26,12.41,12.41,0,0,1,.51-3.59,8.16,8.16,0,0,1,1.52-2.93,6.92,6.92,0,0,1,2.46-2,8,8,0,0,1,3.57-.73,7.68,7.68,0,0,1,3.21.66,8.26,8.26,0,0,1,2.51,1.75A7.39,7.39,0,0,1,45.76,37Z",
    style: {
      fill: "#0075c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.89,63.35V34.25H46.45V29.72H62v4.53H56.59v29.1Z",
    style: {
      fill: "#0075c9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStIcon);
export default __webpack_public_path__ + "static/media/stIcon.666e23df.svg";
export { ForwardRef as ReactComponent };